<template>
  <div class="from-main">
    <v-container
      fill-height
      fluid
      grid-list-md
      class="text-xs-left"
      style="min-height:730px; max-width: 1240px; "
    >
      <v-layout
        row
        wrap
        align-center
        class="text-xs-left"
        :style="{ maxWidth: '1240px' }"
      >
        <v-flex md5>
          <div class="text-xs-left my-4">
            <div class="top-gsmg">
              <img :src="'/img/front_top_gsmg.svg'" alt="GSMG" />
            </div>
            <div class="top-title-1">A fully automated</div>
            <div class="top-title-2">crypto trading bot</div>
            <div style="margin-top: 60px;">
              <v-btn flat to="/register" class="top-get-started"
                >Get started</v-btn
              >
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container
      fill-height
      fluid
      grid-list-md
      :style="{ maxWidth: '1240px' }"
      class="info-container"
    >
      <v-layout row wrap align-center class="text-xs-left info-box">
        <v-flex class="sm6 md3 px-32">
          <div>
            <img :src="'/img/front_stress.svg'" alt="No Stress" />
          </div>
          <div>
            <h3 class="title">
              No Stress
            </h3>
            <p class="box-description">
              Let GSMG take the complexity of day trading out of your hands
            </p>
          </div>
        </v-flex>
        <v-flex class="sm6 md3 px-32">
          <img :src="'/img/front_safe.svg'" alt="Safe" />
          <div>
            <h3 class="title">
              Totally safe
            </h3>
            <p class="box-description">
              Your crypto never leaves your account on the exchange
            </p>
          </div>
        </v-flex>
        <v-flex class="sm6 md3 px-32">
          <img :src="'/img/front_easy.svg'" alt="Easy to use" />
          <div>
            <h3 class="title">
              Easy to use
            </h3>
            <p class="box-description">
              Just connect your account and choose your coins
            </p>
          </div>
        </v-flex>
        <v-flex class="sm6 md3 px-32">
          <img :src="'/img/front_fee.svg'" alt="Try out for free" />
          <div>
            <h3 class="title">
              Try out for free
            </h3>
            <p class="box-description">
              Take advantage of our 6-week free trial period
            </p>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container
      fill-height
      fluid
      grid-list-md
      :style="{ maxWidth: '1240px', padding: '0px' }"
    >
      <v-layout row wrap align-center class="text-xs-center">
        <v-flex md12 style="margin-top: 100px;margin-bottom: 75px;">
          <div class="text-xs-center my-4">
            <iframe
              width="100%"
              height="560"
              src="https://www.youtube.com/embed/xx6K1oxdCoU?rel=0"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </v-flex> </v-layout
    ></v-container>
    <v-container
      fill-height
      fluid
      grid-list-md
      :style="{ maxWidth: '1240px' }"
      class="exchanged-box"
    >
      <v-layout row wrap class="text-xs-center">
        <v-flex xs12 lg2 sm6 md4 offset-md2 class="supported-title">
          Supported exchanges
        </v-flex>
        <v-flex xs12 lg2 sm6 md2>
          <img :src="'/img/front_binance.svg'" alt="Binance" />
        </v-flex>
        <v-flex xs12 lg2 sm6 md2>

        </v-flex>
        <v-flex xs12 lg2 sm6 md2>
          <img :src="'/img/front_huobi.svg'" alt="Huobi" />
        </v-flex>
      </v-layout>
    </v-container>
    <v-container style="margin-top: 100px;">
      <h4 class="price-title text-xs-center">Pricing and Plans</h4>
      <p class="price-description text-xs-center my-4">
        Upon registration you will enter a free trial period of 6 weeks <br />
        (8 with a valid invite code or referral link)
      </p>
      <Subscriptions />
    </v-container>
  </div>
</template>

<script>
import Subscriptions from "../components/Subscriptions";
export default {
  components: { Subscriptions },
  layout: "default",
  metaInfo() {
    return { title: this.$t("home") };
  },
  data: () => ({
    title: window.config.appName
  }),
  methods: {
    downloadFaq() {
      const url = "/faq.pdf";
      window.open(url, "_blank");
    },
    openHelpCenter() {
      const url = "https://intercom.help/gsmg";
      window.open(url, "_blank");
    }
  }
};
</script>

<style scoped>
.top-right {
  position: absolute;
  right: 10px;
  top: 18px;
}

.title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  color: #103a84;
  margin-top: 24px;
}

.argument {
  align-self: start;
  text-align: left;
  display: flex;
  align-items: start;
}

.argument > div {
  margin-left: 10px;
}

.argument .title {
  line-height: 34px !important;
}
.from-main {
  background-image: url("/img/front_bg_1920.svg");
  background-repeat: no-repeat;
  background-position: right top;
  background-color: #f2f7ff;
}
.price-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: 900;
  font-size: 34px;
  line-height: 41px;
  text-align: center;
  letter-spacing: 0.02em;
  color: #103a84;
}
.price-description {
  font-family: "Lato", serif !important;
  font-style: italic;
  font-weight: normal;
  font-size: 18px;
  line-height: 140%;
  text-align: center;
  color: #103a84;
}
.supported-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  color: #103a84;
}
.exchanged-box {
  border-top: solid 2px #d1e2ff;
  border-bottom: solid 2px #d1e2ff;
}
.info-container {
  background: #f2f7ff;
  box-shadow: 4px 6px 20px rgba(57, 95, 169, 0.18);
  border-radius: 30px;
}
.info-box {
  margin: 32px 12px !important;
}
.box-description {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: rgba(16, 58, 132, 0.7);
  margin-top: 16px;
}
.box-height {
  min-height: 220px;
}
.top-gsmg {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: 900;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.1em;
  color: #103a84;
}
.top-title-1 {
  font-family: "Lato", serif !important;
  font-style: italic;
  font-weight: 300;
  font-size: 60px;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: #103a84;
}
.top-title-2 {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: 900;
  font-size: 60px;
  line-height: 140%;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #103a84;
}
.top-get-started {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  background: linear-gradient(180deg, #468aff 0%, #0051dd 100%);
  border-radius: 30px;
  padding: 10px 25px 10px 25px;
  text-decoration: none;
  width: 200px;
  height: 50px;
}
.px-32 {
  padding-left: 32px !important;
  padding-right: 32px !important;
}
@media (max-width: 1919px) {
  .from-main {
    background-image: url("/img/front_bg.svg");
  }
}
@media (max-width: 960px) {
  .from-main {
    background-image: none;
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/pages/welcome.vue